<script lang="ts">
    import { faAsterisk, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount, tick } from 'svelte'
    import Fa from 'svelte-fa'
    const dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let label = ''
    export let value: boolean = false
    if (value === undefined) {
        value = false
    }
    export let size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = null
    export let sizeM: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = 12
    export let disabled: boolean = false
    export let required: boolean = false
    export let help: string = ''

    const internalID = 'id_' + Math.random() * 999999

    let htmlInput

    let _value: any = ''
    $: {
        importValue(value)
    }

    $: {
        exportValue(_value)
    }

    function importValue(v) {
        if (v === undefined || v === null) {
            value = false
            return // return pois será executado novamente
        }
        if (_value === v) return
        try {
            _value = v
        } catch (error) {
        } finally {
        }
    }

    function exportValue(v) {
        if (value === v) return
        value = v
    }

    function setFocus() {
        htmlInput.focus()
    }

    onMount(() => {
        importValue(value)
    })

    function goOnKeyup(ev) {
        dispatch('keyup', ev)
    }

    function goChange(ev) {
        dispatch('change', ev)
    }

    function goFocus(ev) {
        dispatch('focus', ev)
    }

    let tooltip
    let showTooltip = false
    async function goShowTooltip(ev) {
        showTooltip = !showTooltip
        if (!showTooltip) return
        await tick()

        tooltip.style.top = 0
        tooltip.style.left = 0
        let top = ev.clientY - tooltip.clientHeight
        let left = ev.clientX - tooltip.clientWidth
        if (left + tooltip.clientWidth > window.innerWidth - 8) {
            left = window.innerWidth - 8
        }
        if (left - 16 < 0) left = 24
        tooltip.style.top = top - 24 + 'px'
        tooltip.style.left = left - 16 + 'px'
    }

    onMount(() => {})
</script>

<div class="form-check form-switch z-col z-col_w-{size} z-col-m_w-{sizeM} zinput_type-switch {className}" on:focus|stopPropagation={goFocus}>
    <input
        {disabled}
        class="form-check-input"
        bind:checked={_value}
        type="checkbox"
        role="switch"
        id={internalID}
        on:change={goChange}
        on:keyup={goOnKeyup}
        on:focus|stopPropagation={goFocus}
    />
    <label class="form-check-label" for={internalID} on:focus|stopPropagation={goFocus}
        >{label}
        {#if !disabled && required}
            <span class="zinput_required">
                <Fa icon={faAsterisk}></Fa>
            </span>
        {/if}
    </label>

    {#if help}
        <div class="zinput_tooltip" on:click={goShowTooltip}>
            <Fa icon={faQuestionCircle}></Fa>
        </div>
    {/if}
    {#if showTooltip}
        <div bind:this={tooltip} on:click={goShowTooltip} class="zinput_tooltip_content zinput_tooltip_content-show-{showTooltip}">
            {help}
            <div class="zinput_tooltip_content_outer" on:mouseout={goShowTooltip} on:click={goShowTooltip}></div>
        </div>
    {/if}
</div>
